// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"87c6020c","466":"4e565ab9"}[chunkId] + ".chunk.js";
};